module.exports = __webpack_public_path__ + "static/img_4424-c890256fae2a457a593c5998e60c0269.webp";